




































































































import _ from 'lodash';
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { State, Action, namespace } from 'vuex-class';
import {
    ActionError as campaignStoreErr,
    CurrentCampaignType,
    CurrentAdsetType,
} from '@/store/campaign/types';

import { Setting as terms } from '@/const/terms/mainTerms';
import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';
import { EditAd as feedbackTerms } from '@/const/terms/feedback/ad';
import { SetCampaign as campaignFeedback} from '@/const/terms/feedback/campaign';
import { SetAdset as adsetFeedback} from '@/const/terms/feedback/adset';

import { ID_TYPE, AD_FORMAT_KEY, AD_FORMAT, INVENTORY_TYPE } from '@/const/types';
import { AD_FORMAT_MAP, INVENTORY_TYPE_MAP } from '@/const/options/index';
import {
    FormType,
    OriginCreative,
    LoadedCreative,
    AdFolderType,
    LoadedCreativeMapByInventoryID,
    CreativeResponse,
    ICreative,
    IResponseCreative,
    IInventoryAsTableRow,
    InventoryFormResponse,
    IInventoryResponse,
    ICreativeToRequest,
} from './editingTypes';
import { IAdsetSummary, IAdsetBrief, AdsetResponse } from '../types';
import { CampaignInfoResponse } from '../../editingTypes';
import { ElTable } from 'element-ui/types/table';

import { ElForm } from 'element-ui/types/form';
import { AxiosError, AxiosResponse } from 'axios';

import AdForm from '@/components/pages/ad/AdForm.vue';
import AdFolderSelectDialog from '@/components/pages/ad/AdFolderSelectDialog.vue';

const campaignModule = namespace('Campaign');

@Component<AdEdit>({
    name: 'AdEdit',
    components: {
        AdForm,
        AdFolderSelectDialog,
    },
    beforeRouteLeave (to: any, from: any, next: any) {
        if ( !this.isModified || this.isSubmit || to.name === 'login') {
            next();
        } else {
            this.$confirm(feedbackTerms.other.confirm.warnIsModified,'Warning', {
                confirmButtonText: '네',
                cancelButtonText: '아니오',
                type: 'warning'
            }).then((confirm: any) => {
                next();
            })
            .catch(() => {})
        }
    },
})
export default class AdEdit extends Vue {
    private terms = terms;
    private compTerms = compTerms;
    
    private isSubmit: boolean = false;

    private loading: boolean = false;
    private subLoading: number = 0;
    private AD_FORMAT_MAP = AD_FORMAT_MAP;
    private INVENTORY_TYPE_MAP = INVENTORY_TYPE_MAP;
        
    private zoomImgDialogVisible: boolean = false;
    private zoomImg: OriginCreative | LoadedCreative | null = null;

    private adFolderDialogVisible: boolean = false;
    private appliedAdFolders: AdFolderType[] = [];

    private form: FormType = {
        inventory: [],
    };


    get whichLocation() {
        return this.$route.path.split('/').splice(-1, 1)[0].toLowerCase();
    }
    get isInit() {
        if (this.$route.params) {
            if (this.currentAdset.idList) {
                if (this.$route.path.split('/').splice(-1, 1)[0].toLowerCase() === 'init') {
                    return true;
                }
            }
        }
        return false;
    }
    @campaignModule.State('currentCampaign') private currentCampaign!: CurrentCampaignType;
    @campaignModule.State('currentAdset') private currentAdset!: CurrentAdsetType;
    @campaignModule.Action('SET_CURRENT_CAMPAIGN') private setCurrentCampaign!: any;
    @campaignModule.Action('SET_CURRENT_ADSET') private setCurrentAdset!: any;

    get isModified() {
        const model = this.form;
        const {loaded, notUsed} = model.inventory.reduce((pre: {loaded: number, notUsed: number}, inv: IInventoryAsTableRow) => {
            pre.loaded += inv.usable.length;
            pre.notUsed += inv.usable.filter((creative: LoadedCreative) => !(creative.origin || creative.selected)).length
            return pre;
        }, {loaded: 0, notUsed: 0})
        return loaded !== notUsed;
    }
    private cancelForm() {
        this.$router.push({name: 'ad', params: this.$route.params});
    }
    private validateForm(){
        const formWrapper = this.$refs.formWrapper as AdForm;
        const form = formWrapper.$refs.form as ElForm;
        form.validate().then((valid: boolean) => {
            if (valid) {
                this.submit(form.model as FormType).then((res: any) => res.data)
                    .then((data: {result: boolean}) => {
                        if (data && data.result) {
                            this.$notify.success(feedbackTerms.editing.success);
                            this.isSubmit = true;
                            this.$router.push({
                                name: 'ad',
                                params: this.$route.params,
                            });
                        } else {
                            this.$notify.error(feedbackTerms.editing.error.fail);
                        }
                    });
            } else {
                return false;
            }
        }).catch((err: boolean) => {
            if (err === false) {
                const errorField = (form as any).fields.find((f: any) => f.validateState === 'error') as Vue;
                if (errorField) {
                    const el = errorField.$el.querySelector('input') as HTMLElement;
                    el.focus();
                }
            }
        })
    }
    private submit(model: FormType) {
        const reqData = model.inventory.reduce((pre: ICreativeToRequest[], inv: IInventoryAsTableRow) => {
            const creatives = inv.creative.map((creative: OriginCreative) => ({
                    adset_id: inv.adset_id,
                    folder_id: creative.folder_id,
                    id: creative.id,
                    url:creative.url,
                    width: inv.format_raw.width,
                    height: inv.format_raw.height,
                })
            )
            return [
                ...pre,
                ...creatives,
            ];
        }, [])

        return this.$http.adserverAPI.post('UpdateAdsetCreativeMatch', {
            creatives: reqData,
            adset_ids: this.currentAdset.idList,
        });
    }
    // private submit(model: FormType) {
    //     return Promise.resolve(true);
    // }
    

    private adFolderCreativeLoadHandler(IDList: ID_TYPE[]) {
        this.subLoading++;
        this.getUsableCreativeHandler(IDList)
            .then((res: any) => {
                this.subLoading--;
                if (this.subLoading === 0) {
                    this.adFolderDialogVisible = false;
                }
            })
    }
    private getUsableCreativeHandler(arr: ID_TYPE[]) {
        return this.getUsableCreative(arr).then((res: any) => res.data)
        .then((data: CreativeResponse) => {
            const usableMap = {} as LoadedCreativeMapByInventoryID;
            this.form.inventory.forEach((inventory: IInventoryAsTableRow) => {
                const appliedIDList = inventory.creative.map((creative: OriginCreative) => creative.id) as ID_TYPE[];
                const originIDList = [
                    ...inventory.creative.filter((creative: OriginCreative) => creative.origin).map((creative: OriginCreative) => creative.id) as ID_TYPE[],
                    ...inventory.usable.filter((creative: LoadedCreative) => creative.origin).map((creative: LoadedCreative) => creative.id) as ID_TYPE[],
                ]

                const matched = data.filter((item: IResponseCreative) => {
                    const key = AD_FORMAT_KEY(item.type, item.format_raw.width, item.format_raw.height);
                    const format = AD_FORMAT[key];
                    return inventory.format === format && !originIDList.includes(item.id);
                })
                if ( matched.length > 0 ) {
                    if (!usableMap.hasOwnProperty(inventory.inventoryID)) usableMap[inventory.inventoryID] = {};

                    const id = usableMap[inventory.inventoryID]
                    if (!id.hasOwnProperty(inventory.type)) id[inventory.type] = {};

                    const type = id[inventory.type]
                    if (!type.hasOwnProperty(inventory.format)) type[inventory.format] = [];

                    type[inventory.format] = [
                        ...type[inventory.format],
                        ...matched.map((image: IResponseCreative ) => {
                            const key = AD_FORMAT_KEY(image.type, image.format_raw.width, image.format_raw.height);
                            const format = AD_FORMAT[key];
                            return {
                                selected:       appliedIDList.includes(image.id) ? true : false,
                                origin:         false,
                                id:             image.id,
                                folder_id:      image.folder_id,
                                name:           image.name,
                                type:           image.type,
                                sspFormat:      image.sspFormat,
                                format:         format,
                                url:            image.url,
                                bg_color:       image.bg_color,
                            } as LoadedCreative;
                        }),
                    ];
                }
            })
            return usableMap;
        })
        .then((usableMap: LoadedCreativeMapByInventoryID) => {
            this.form.inventory.forEach((item: IInventoryAsTableRow) => {
                const usable = usableMap[item.inventoryID] && usableMap[item.inventoryID][item.type] && usableMap[item.inventoryID][item.type][item.format]
                            ? usableMap[item.inventoryID][item.type][item.format] : [];

                item.usable = [
                    ...item.usable.filter((creative: LoadedCreative) => creative.origin),
                    ...usable,
                ];
                const usableIDList = item.usable.map((creative: LoadedCreative) => creative.id) as ID_TYPE[];

                item.creative = [
                    ...item.creative.filter((creative: OriginCreative) => {
                        return creative.origin || usableIDList.includes(creative.id)
                    }),
                ];
            })
        })
        .catch((err: AxiosError) => {
            if (err.response && (err.response as AxiosResponse).status !== 200) {
                this.$notify.error(feedbackTerms.getResponse.error.fail);
            } else {
                this.$notify.error(err.message);
            }
            throw err;
        })
    }
    private getAppliedDataHandler() {
        this.loading = true;
        this.getAppliedData().then((res: any) => res.data)
            .then((data: InventoryFormResponse) => {
                this.form.inventory = data.map((inv: IInventoryResponse) => {
                    const key = AD_FORMAT_KEY(inv.type, inv.format_raw.width, inv.format_raw.height)
                    const format = AD_FORMAT[key];
                    return {
                        adset_id: inv.adset_id,
                        inventoryID: inv.inventoryID,
                        name: inv.name,
                        type: inv.type,
                        sspFormat: inv.sspFormat,
                        format: format,
                        format_raw: inv.format_raw,
                        usable: [],
                        creative: inv.creative.map((image: IResponseCreative) => {
                            const key = AD_FORMAT_KEY(inv.type, inv.format_raw.width, inv.format_raw.height);
                            const format = AD_FORMAT[key];
                            return {
                                origin:         true,
                                id:             image.id,
                                folder_id:      image.folder_id,
                                name:           image.name,
                                type:           inv.type,
                                format:         format,
                                sspFormat:      inv.sspFormat,
                                url:            image.url,
                                bg_color:       image.bg_color,
                            } as OriginCreative;
                        }),
                    } as IInventoryAsTableRow;
                }) ;
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(()=> {
                this.loading = false;
            })
    }
    private getUsableCreative(arr: ID_TYPE[]): Promise<any> {
        return this.$http.adserverAPI.post('GetCreativeList', {
            folder_ids: arr,
        })
    }

    private getAppliedData(): Promise<any> {
        const adset_ids = this.currentAdset.idList;
        return this.$http.adserverAPI.post('GetCreativeInfo', {
            adset_ids: adset_ids,
        })
    }

    private initData() {
        this.getAppliedDataHandler();
    }

    private async created() {
        if (this.$route.params.campaignID !== this.currentCampaign.id) {
            const campaignID = this.$route.params.campaignID;
            await this.$http.adserverAPI.post('GetCampaignInfo', {campaign_id: campaignID}).then((res: any) => res.data)
                .then(async (data: CampaignInfoResponse) => {
                    if (data && (data as any).result === null) {
                        throw new Error(campaignFeedback.getResponse.error.notFound);
                    }
                    try {
                        await this.setCurrentCampaign({
                            id: data.id,
                            name: data.name,
                            app: data.app,
                        });
                    } catch (err) {
                        switch (err.type) {
                            case campaignStoreErr.SET_CURRENT_CAMPAIGN:
                                throw new Error(campaignFeedback.getResponse.error.setCurrentCampaign);
                                break;
                        }
                        throw new Error(campaignFeedback.getResponse.error.fail);
                    }
                })
                .catch((err: AxiosError) => {
                    if (err.response && (err.response as AxiosResponse).status !== 200) {
                        this.$notify.error(campaignFeedback.getResponse.error.fail);
                    } else {
                        this.$notify.error(err.message);
                        this.isSubmit = true;
                        this.$router.push({name: 'campaign'});
                    }
                    throw err;
                })
            
        }
        if (this.$route.params.adsetGroup !== this.currentAdset.name) {
            const groupName = this.$route.params.adsetGroup;
            await this.$http.adserverAPI.post('GetAdsetReport', {
                campaign_id: this.currentCampaign.id,
                placements: ['1','2','3','4','5','6'],
                since: moment(Date.now()).format('YYYYMMDDHH'),
                until: moment(Date.now()).format('YYYYMMDDHH'),
                page_no: 0,
            }).then((res: any) => res.data)
                .then( async (data: AdsetResponse) => {
                    const target = data.adsets.find((adset: IAdsetSummary) => adset.name === groupName)
                    if (target) {
                        try {
                            await this.setCurrentAdset({
                                idList: target.targets.map((inv: IAdsetBrief) => inv.adset_id),
                                name: target.name
                            })
                        } catch (err) {
                            switch (err.type) {
                                case campaignStoreErr.SET_CURRENT_ADSET:
                                    this.$notify.error(adsetFeedback.currentAdset.error.fail);
                                    break;
                            }
                            throw err;
                        }
                    } else {
                        throw new Error(adsetFeedback.getResponse.error.notFound);
                    }
                })
                .catch((err: AxiosError) => {
                    if (err.response && (err.response as AxiosResponse).status !== 200) {
                        this.$notify.error(adsetFeedback.getResponse.error.fail);
                    } else {
                        this.$notify.error(err.message);
                        this.isSubmit = true;
                        this.$router.push({name: 'adset', params: {campaignID: this.currentCampaign.id.toString()}});
                    }
                    throw err;
                })
        }
        this.initData();
    }
}
